// format number with commas and add decimal places
export const numberWithCommas = (x: number, decimals: number = 0, currency: boolean = false) => {
  return new Intl.NumberFormat('en', {
    minimumFractionDigits: decimals,
    currency: 'USD',
    style: currency ? 'currency' : 'decimal',
  }).format(x);
};

export const roundNumberToXDecimals = (value: number, decimals: number) => {
  return +(Math.round(+(value + 'e' + decimals)) + 'e-' + decimals);
};
